import React from 'react';
import ActivityLog from '../components/ActivityLog/ActivityLog';

const ActivityLogPage = () => {
  return <ActivityLog />;
};

export default ActivityLogPage;
